webpackJsonp([17],{

/***/ "F5Ue":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("HuKA");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("0b8050e5", content, true, {});

/***/ }),

/***/ "GmTP":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("dIjx");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("3a1cce5d", content, true, {});

/***/ }),

/***/ "HuKA":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(true);
// imports


// module
exports.push([module.i, ".handle[data-v-2fba79ba]{z-index:4;margin-right:5px}.linkEditorContainer[data-v-2fba79ba]{padding:20px;border-bottom-color:silver;border-bottom-width:1px;border-bottom-style:solid}.md-select-content[data-v-2fba79ba]{width:100%!important}#toolbar[data-v-2fba79ba]{z-index:1}body[data-v-2fba79ba]{background-color:\"#f5f5f5\"}section[data-v-2fba79ba]{padding-bottom:30px}h1[data-v-2fba79ba],h2[data-v-2fba79ba]{font-weight:400;text-align:center}h2[data-v-2fba79ba]{font-size:10ex}ul[data-v-2fba79ba]{list-style-type:none;padding:0}li[data-v-2fba79ba]{display:inline-block;margin:0 10px}a[data-v-2fba79ba]{color:#42b983}#toolbar[data-v-2fba79ba]{position:sticky;position:-webkit-sticky;top:0}#profileBackground[data-v-2fba79ba]{background-color:#fff;padding-top:15px;background-position:50%;background-repeat:no-repeat;background-size:150vw;text-align:center}#profilePic[data-v-2fba79ba]{background-position:50%;background-repeat:no-repeat;background-size:cover;border-radius:50%;border:3px solid hsla(0,0%,100%,.75);margin-left:auto;margin-right:auto}#slinkName[data-v-2fba79ba]{color:#000;font-size:18px;margin-top:10px;margin-bottom:10px;padding-left:10px;padding-right:10px;background-color:rgba(0,0,0,.25);white-space:nowrap;display:inline-block;border-radius:10px}.md-list-item-container[data-v-2fba79ba]{padding:10px 16px}.md-tab[data-v-2fba79ba]{padding:unset;padding-top:20px;padding-bottom:48px}.compactContainer[data-v-2fba79ba]{padding:unset;min-height:unset;margin-bottom:12px;font-size:12px!important}.userSearchBar[data-v-2fba79ba]{width:100%;background-color:silver}", "", {"version":3,"sources":["C:/Users/ismet/Documents/Github/slink_vue/src/components/404.vue"],"names":[],"mappings":"AACA,yBACE,UAAW,AACX,gBAAgB,CACjB,AACD,sCACE,aAAa,AACb,2BAA2B,AAC3B,wBAAwB,AACxB,yBAA0B,CAC3B,AACD,oCACE,oBAAsB,CACvB,AACD,0BAEE,SAAW,CACZ,AACD,sBACE,0BAA+B,CAChC,AACD,yBACE,mBAAoB,CACrB,AACD,wCACE,gBAAoB,AAEpB,iBAAmB,CACpB,AACD,oBACE,cAAe,CAChB,AACD,oBACE,qBAAsB,AACtB,SAAW,CACZ,AACD,oBACE,qBAAsB,AACtB,aAAe,CAChB,AACD,mBACE,aAAe,CAChB,AACD,0BACE,gBAAgB,AAChB,wBAAyB,AACzB,KAAQ,CACT,AACD,oCACE,sBAAuB,AACvB,iBAAiB,AACjB,wBAA4B,AAC5B,4BAA6B,AAE7B,sBAAuB,AACvB,iBAAmB,CACpB,AACD,6BACE,wBAA4B,AAC5B,4BAA6B,AAC7B,sBAAsB,AAKtB,kBAAmB,AACnB,qCAA2C,AAC3C,iBAAiB,AACjB,iBAAkB,CACnB,AACD,4BACE,WAAY,AACZ,eAAe,AACf,gBAAgB,AAChB,mBAAmB,AACnB,kBAAkB,AAClB,mBAAmB,AACnB,iCAAqC,AACrC,mBAAmB,AACnB,qBAAqB,AACrB,kBAAmB,CACpB,AACD,yCACE,iBAAmB,CACpB,AACD,yBACE,cAAc,AACd,iBAAiB,AACjB,mBAAmB,CACpB,AACD,mCACE,cAAe,AACf,iBAAkB,AAClB,mBAAoB,AACpB,wBAAyB,CAC1B,AACD,gCACE,WAAW,AACX,uBAAuB,CACxB","file":"404.vue","sourcesContent":["\n.handle[data-v-2fba79ba] {\r\n  z-index: 4;\r\n  margin-right:5px\n}\n.linkEditorContainer[data-v-2fba79ba]{\r\n  padding:20px;\r\n  border-bottom-color:silver;\r\n  border-bottom-width:1px;\r\n  border-bottom-style:solid;\n}\n.md-select-content[data-v-2fba79ba]{\r\n  width:100% !important;\n}\n#toolbar[data-v-2fba79ba]{\r\n  position:sticky;\r\n  z-index:1 ;\n}\nbody[data-v-2fba79ba]{\r\n  background-color: \"whitesmoke\";\n}\nsection[data-v-2fba79ba]{\r\n  padding-bottom:30px;\n}\nh1[data-v-2fba79ba], h2[data-v-2fba79ba] {\r\n  font-weight: normal;\r\n  /* font-family: 'Pacifico'; */\r\n  text-align: center;\n}\nh2[data-v-2fba79ba]{\r\n  font-size:10ex;\n}\nul[data-v-2fba79ba] {\r\n  list-style-type: none;\r\n  padding: 0;\n}\nli[data-v-2fba79ba] {\r\n  display: inline-block;\r\n  margin: 0 10px;\n}\na[data-v-2fba79ba] {\r\n  color: #42b983;\n}\n#toolbar[data-v-2fba79ba]{\r\n  position:sticky;\r\n  position: -webkit-sticky;\r\n  top:0px;\n}\n#profileBackground[data-v-2fba79ba]{\r\n  background-color:white;\r\n  padding-top:15px;\r\n  background-position: center;\r\n  background-repeat: no-repeat;\r\n  /* background-size:cover; */\r\n  background-size: 150vw;\r\n  text-align: center;\n}\n#profilePic[data-v-2fba79ba]{\r\n  background-position: center;\r\n  background-repeat: no-repeat;\r\n  background-size:cover;\r\n  /* width: 100px;\r\n  height: 100px;\r\n  max-width: 100px;\r\n  max-height: 100px; */\r\n  border-radius: 50%;\r\n  border: 3px solid rgba(255, 255, 255, .75);\r\n  margin-left:auto;\r\n  margin-right:auto;\n}\n#slinkName[data-v-2fba79ba]{\r\n  color:black;\r\n  font-size:18px;\r\n  margin-top:10px;\r\n  margin-bottom:10px;\r\n  padding-left:10px;\r\n  padding-right:10px;\r\n  background-color:rgba(0, 0, 0, 0.25);\r\n  white-space:nowrap;\r\n  display:inline-block;\r\n  border-radius:10px;\n}\n.md-list-item-container[data-v-2fba79ba]{\r\n  padding: 10px 16px;\n}\n.md-tab[data-v-2fba79ba]{\r\n  padding:unset;\r\n  padding-top:20px;\r\n  padding-bottom:48px\n}\n.compactContainer[data-v-2fba79ba]{\r\n  padding: unset;\r\n  min-height: unset;\r\n  margin-bottom: 12px;\r\n  font-size:12px !important\n}\n.userSearchBar[data-v-2fba79ba]{\r\n  width:100%;\r\n  background-color:silver\n}\r\n\r\n\r\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ "dIjx":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(true);
// imports


// module
exports.push([module.i, "body,h1{font-family:GoogleSans,Roboto,Noto Sans,Noto,sans-serif!important;font-weight:bolder!important;display:-webkit-box;display:-ms-flexbox;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;text-transform:uppercase;height:100vh;display:flex;-ms-flex-line-pack:center;align-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;line-height:normal;padding:10px}#app{padding:10px;border-radius:50px;overflow:hidden}.md-tabs-navigation{position:fixed!important;width:100%}.md-tabs-content{margin-top:50px}.fullScreenDialog .md-dialog{min-width:100%;max-width:100%;width:100%;max-height:100%;height:100%;top:0}.userInformation{margin:unset}.userInformation .md-list-item-container{padding:0 0 10px}.md-list-item .md-button:not(.md-button-ghost):not(.md-list-item-container){padding:unset;margin-bottom:5px;height:unset;min-height:unset;width:unset;min-width:22px}.pictureUploader input{display:none}", "", {"version":3,"sources":["C:/Users/ismet/Documents/Github/slink_vue/src/components/404.vue"],"names":[],"mappings":"AACA,QAEE,kEAAyE,AACzE,6BAA8B,AAC9B,oBAAoB,AACpB,oBAAoB,AAEpB,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AAC1B,aAAc,AACZ,aAAc,AACd,0BAA2B,AACvB,qBAAsB,AAC1B,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,mBAAoB,AACtB,YAAa,CACd,AACD,KAEE,aAAa,AACb,mBAAmB,AACnB,eAAgB,CACjB,AACD,oBACE,yBAA2B,AACzB,UAAY,CACf,AACD,iBACE,eAAgB,CACjB,AACD,6BACE,eAAgB,AAChB,eAAgB,AAChB,WAAW,AAEX,gBAAgB,AAChB,YAAa,AAGb,KAAS,CACV,AAeD,iBACE,YAAa,CACd,AACD,yCACE,gBAA0B,CAC3B,AACD,4EACE,cAAe,AACf,kBAAmB,AACnB,aAAc,AACd,iBAAkB,AAClB,YAAa,AACb,cAAgB,CACjB,AACD,uBACE,YAAa,CACd","file":"404.vue","sourcesContent":["\nbody, h1{\r\n  /* background-color: \"whitesmoke\"; */\r\n  font-family: GoogleSans,Roboto, \"Noto Sans\", Noto, sans-serif !important;\r\n  font-weight:bolder !important;\r\n  display:-webkit-box;\r\n  display:-ms-flexbox;\r\n  display:flex;\r\n  -webkit-box-pack: center;\r\n      -ms-flex-pack: center;\r\n          justify-content: center;\r\n  text-transform: uppercase;\r\n  height: 100vh;\r\n    display: flex;\r\n    -ms-flex-line-pack: center;\r\n        align-content: center;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n    line-height: normal;\r\n  padding:10px;\n}\n#app{\r\n  /* border:5px solid #E4B2F3; */\r\n  padding:10px;\r\n  border-radius:50px;\r\n  overflow:hidden;\n}\n.md-tabs-navigation{\r\n  position: fixed !important;\r\n    width: 100%;\n}\n.md-tabs-content{\r\n  margin-top:50px;\n}\n.fullScreenDialog .md-dialog{\r\n  min-width: 100%;\r\n  max-width: 100%;\r\n  width:100%;\r\n  /* max-height: calc(100% - 48px); */\r\n  max-height:100%;\r\n  height: 100%;\r\n  /* height: calc(100% - 48px); */\r\n  \r\n  top: 0px;\n}\r\n\r\n/* #selectSite .md-dialog {\r\n  max-width: 100%;\r\n  max-height: calc(100% - 48px);\r\n  top: 24px;\r\n} */\r\n\r\n/* #addSite .md-dialog {\r\n  max-width: 100%;\r\n  width:100%;\r\n  max-height: calc(100% - 48px);\r\n  height: calc(100% - 48px);\r\n  top: 24px;\r\n} */\n.userInformation{\r\n  margin:unset;\n}\n.userInformation .md-list-item-container{\r\n  padding: 0px 0px 10px 0px;\n}\n.md-list-item .md-button:not(.md-button-ghost):not(.md-list-item-container) {\r\n  padding: unset;\r\n  margin-bottom: 5px;\r\n  height: unset;\r\n  min-height: unset;\r\n  width: unset;\r\n  min-width: 22px;\n}\n.pictureUploader input{\r\n  display: none\n}\r\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ "pg2O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebaseconfig__ = __webpack_require__("89vL");
//
//
//
//
//
//
//
//
//


// import draggable from 'vuedraggable'
// import linkinfo from "./linkinfo_component";
// import siteicon from "./siteicon_component";


var db = __WEBPACK_IMPORTED_MODULE_0__firebaseconfig__["b" /* fb */].database();

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    // draggable,
    // linkinfo,
    // siteicon,
  },
  name: 'NotFound',
  data: function data() {
    return {};
  },

  mounted: function mounted() {},
  firebase: function firebase() {
    // this.loadingStatus = true
    return {
      // sites: {source: db.ref('customsite/').orderByChild('site'),anObject: false, cancelCallback: function() {}, readyCallback: function(){
      //   }},
      // ads: db.ref('ads')
      // ads: db.ref('ads')//.orderByChild('active')
    };
  },
  computed: {},
  methods: {}
});

/***/ }),

/***/ "tfjM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background-color":"white"},attrs:{"id":"home"}},[_c('h1',[_vm._v("Oh no! The page you are looking for can't be found!")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "thLP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_404_vue__ = __webpack_require__("pg2O");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fba79ba_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_404_vue__ = __webpack_require__("tfjM");
function injectStyle (ssrContext) {
  __webpack_require__("GmTP")
  __webpack_require__("F5Ue")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2fba79ba"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_404_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fba79ba_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_404_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ })

});


// WEBPACK FOOTER //
// static/js/17.99a8c0eabecf4aebb9fc.js